import {isEmpty} from 'lodash';
import subDays from 'date-fns/sub_days';
import addDays from 'date-fns/add_days';
import isAfter from 'date-fns/is_after';
import startOfDay from 'date-fns/start_of_day';

export const ValidatorTypes = {
    PATTERN: 'PATTERN',
    VALUE: 'VALUE',
    FUNCTION: 'FUNCTION'
};
const emailReg = /^(\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*)*$/;

export default {
    integer: {
        type: ValidatorTypes.PATTERN,
        value: /^(?:0|[1-9]\d*)$/,
        message: '请输入整数'
    },
    alphabetic: {
        type: ValidatorTypes.PATTERN,
        value: /^[a-zA-Z]*$/,
        message: '请输入英文字母'
    },
    number: {
        type: ValidatorTypes.PATTERN,
        value: /^\d*$/,
        message: '请输入数字'
    },
    chinese: {
        type: ValidatorTypes.PATTERN,
        value: /^[\u4E00-\u9FFF]*$/,
        message: '请输入中文'
    },
    name: {
        type: ValidatorTypes.PATTERN,
        value: /^[\da-zA-Z\u4E00-\u9FFF]+$/,
        message: '请输入数字，字母或汉字'
    },
    pattern: {
        type: ValidatorTypes.PATTERN
    },
    required: {
        type: ValidatorTypes.VALUE,
        value: true
    },
    strongRequired: {
        type: ValidatorTypes.PATTERN,
        value: /\S/,
        message: '请输入'
    },
    sameWith: {
        type: ValidatorTypes.FUNCTION,
        validate(val, ruleArg, formData) {
            // return val === formData[ruleArg];
            return true;
        },
        message: '不一致'
    },
    notEmpty: {
        type: ValidatorTypes.FUNCTION,
        validate(val) {
            return !isEmpty(val);
        },
        message: '请填写'
    },
    afterDate: {
        type: ValidatorTypes.FUNCTION,
        validate(val, ruleArgs) {
            if (!val) {
                return true;
            }
            let day = null;
            switch (ruleArgs[0]) {
                case 'today':
                    day = startOfDay(new Date());
                    break;
                case 'tomorrow':
                    day = startOfDay(addDays(new Date(), 1));
                    break;
                case 'yesterday':
                    day = startOfDay(subDays(new Date(), 1));
                    break;
                default:
                    day = startOfDay(subDays(new Date(), 1));
                    break;
            }
            return isAfter(startOfDay(val), day);
        },
        message: '时间不能晚于今天'
    },
    password: {
        type: ValidatorTypes.PATTERN,
        value: /^(?![^a-z]+$)(?![^A-Z]+$)(?![^\d]+$)[\da-zA-Z]{6,32}$/,
        message: '请输入包含数字、大、小写字母，长度6到32位'
    },
    maxLength: {
        type: ValidatorTypes.VALUE
    },
    minLength: {
        type: ValidatorTypes.VALUE
    },
    email: {
        type: ValidatorTypes.PATTERN,
        value: emailReg,
        message: '请输入有效的电子邮箱'
    },
    mobile: {
        type: ValidatorTypes.PATTERN,
        value: /^(1[34578]\d{9})$/,
        message: '请输入有效的电话号码'
    },
    httpUrl: {
        type: ValidatorTypes.PATTERN,
        value: /^(?:https?):\/\/.*\..+$/,
        message: '请输入正确的url格式'
    },
    idCard: {
        type: ValidatorTypes.PATTERN,
        value: /^\d{17}[0-9X]$/,
        message: '请输入18位身份证号'
    },
    qualificationName: {
        // 暂时写个这个，因为这个pattern需要validator正式支持
        type: ValidatorTypes.PATTERN,
        value: /^([\u4E00-\u9FFF]{2,4}|[a-z ,.'-]{2,20})$/,
        message: '2-4位长的中文名或者2-20个字符的英文名'
    },
    multiEmail: {
        type: ValidatorTypes.FUNCTION,
        validate(val) {
            if (val === '') {
                return true;
            }
            if (val[val.length - 1] === ',') {
                val = val.slice(0, val.length - 1);
            }
            const emails = val.split(/\s*,\s*/);
            const allPassed = emails.every(item => {
                const trimed = item.trim();
                return trimed && emailReg.test(trimed);
            });
            return allPassed;
        },
        message: '邮箱数据格式错误'
    }
};
